module.exports = __webpack_public_path__ + "img/faturas_bg.da65b2c3.webp";